import 'isomorphic-fetch';
import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import { client } from './utils/apollo';

import { HashRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { getProjectSubDomain, apps } from './utils/routing';
import { setupVersion } from './config/configHelper';

const project = getProjectSubDomain();

const Provider = () => {
  setupVersion();
  return (
    <div id="solar">
      <ApolloProvider client={client}>
        <Router>
          <Switch>
            <Redirect exact from={'/'} to={`/${project}`} />
            <Redirect exact from={'/request-a-quote'} to={`/${project}/request-a-quote`} />
            <Redirect exact from={'/general-enquiry'} to={`/${project}/general-enquiry`} />
            <Redirect exact from={'/customer-enquiry'} to={`/${project}/general-enquiry`} />
            <Route path={`/${project}`} component={apps[project]} />
          </Switch>
        </Router>
      </ApolloProvider>
    </div>
  );
};

//@ts-ignore
const ApolloApp = __DEV__ ? require('react-hot-loader').hot(module)(Provider) : Provider;

export { ApolloApp as default };
